








import { useLogoDestination } from '@app/shared/composables/useLogoDestination';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { SdsLogo } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    setup() {
        const logoDestination = useLogoDestination();

        return {
            brand: shellLocalConfig.logo,
            logoDestination,
        };
    },
    components: {
        SdsLogo,
    },
});
